export default "__VITE_ASSET__CeCfhQUf__"